import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import type { DeepReadonly } from '../../../server/util-type';
import type { OrgTaskWithUpdates } from '../task.service';

@Component({
  selector: 'app-delete-task-dialog',
  templateUrl: './delete-task-dialog.component.html',
  styleUrls: ['./delete-task-dialog.component.scss'],
  standalone: false,
})
export class DeleteTaskDialogComponent {
  private dialogRef = inject(MatDialogRef<DeleteTaskDialogComponent>);
  private readonly data: {
    task: DeepReadonly<OrgTaskWithUpdates>;
  } = inject(MAT_DIALOG_DATA);

  task: DeepReadonly<OrgTaskWithUpdates>;

  constructor() {
    this.task = this.data.task;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  accept(): void {
    this.dialogRef.close(true);
  }
}
